/* tslint:disable */
/* eslint-disable */
export enum MultipleSessionsOption {
  AllowMultiple = 0,
  EndExistingSession = 1,
  NotAllowed = 2
}
